import Add from '@mui/icons-material/Add'
import { LoadingButton } from '@mui/lab'
import { ListItem, ListItemText, useTheme } from '@mui/material'

interface Props {
  title: string
  onClick: () => void
  isLoading?: boolean
  disabled?: boolean
  'data-cy'?: string
}

const AddPlanItemButton = ({
  title,
  onClick,
  isLoading = false,
  disabled = false,
  'data-cy': dataCy,
}: Props) => {
  const theme = useTheme()

  return (
    <ListItem>
      <ListItemText
        primary={title}
        slotProps={{
          primary: {
            color: disabled ? theme.palette.text.disabled : undefined,
          },
        }}
      />
      <LoadingButton
        disabled={disabled}
        variant="outlined"
        loading={isLoading}
        onClick={onClick}
        data-cy={`button-${dataCy}`}
      >
        <Add fontSize={'small'} />
      </LoadingButton>
    </ListItem>
  )
}

export default AddPlanItemButton
